import { render, staticRenderFns } from "./DashboardNotifications.vue?vue&type=template&id=16c375d3&scoped=true"
import script from "./DashboardNotifications.vue?vue&type=script&lang=js"
export * from "./DashboardNotifications.vue?vue&type=script&lang=js"
import style0 from "./DashboardNotifications.vue?vue&type=style&index=0&id=16c375d3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c375d3",
  null
  
)

export default component.exports